import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import {Autocomplete} from "@material-ui/lab";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import {ajustesResources, eliminarConteoResources, tagResources} from "../endpoints";

class DialogRestaurarConteoEliminado extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            datos_conteo : props.conteo,
            motivos:[],
            motivo: ""
        }
    }

    getMotivos = () =>{
        ajustesResources.getMotivosAjustes().then(async response => {
            if (response.ok) {
                return await response.json();
            } else {
                throw new Error('Something went wrong ...');
            }
        }).then(result => {
            this.setState({motivos:result})
        }).catch(error=> {
            console.log(error)
        });
    }

    restaurarConteo = ()=>{
        if(this.props.recuperar === "conteo"){
            eliminarConteoResources.restaurarConteoEliminado(this.state.datos_conteo.id,this.state.motivo.id).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(result => {
                if(result.message){
                    this.props.refrescar(result.message,result.severity)
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                console.log(error)
                this.props.refrescar("Ha ocurrido un error inesperado", "error")
            });
        }
        else{
            //En este caso el conteo es el tag
            tagResources.restaurarTagEliminado(this.state.datos_conteo, this.state.motivo.id).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(result => {
                if(result.message){
                    this.props.refrescar(result.message,result.severity)
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                console.log(error)
                this.props.refrescar("Ha ocurrido un error inesperado", "error")
            });
        }
    }


    componentDidMount() {
        this.getMotivos()
    }

    render() {
        return(
            <Dialog
                open={true}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">{this.props.title}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} alignItems="flex-end">
                        {this.props.recuperar === "conteo" ?
                        <Grid item xs={12}>
                            Material: {this.state.datos_conteo.articulo}
                        </Grid> : null}
                        {this.props.recuperar === "conteo" ?
                        <Grid item xs={12}>
                            Descripción material: {this.state.datos_conteo.descripcion}
                        </Grid>: null}
                        {this.props.recuperar === "conteo" ?
                        <Grid item xs={12}>
                            Cantidad actual: {this.state.datos_conteo.cantidad}
                        </Grid>:null}
                        <Grid item xs={12}>
                            Seleccione un motivo:
                            <Autocomplete
                                id="size-small-standard"
                                onChange={(event, newValue) => {
                                    if(newValue === null) {
                                        this.setState({motivo: ""})
                                    }
                                    else{
                                        this.setState({motivo: newValue})
                                    }
                                }}
                                size="small"
                                options={this.state.motivos}
                                noOptionsText={"No hay opciones"}
                                getOptionLabel={(option) => option.descripcion|| ""}
                                renderInput={(params) => (
                                    <TextField {...params} variant="standard" label="Motivo" placeholder="Disponibles" />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            {this.props.recuperar === "conteo" ?
                                "Está seguro que desea restaurar el conteo?" :
                                "Está seguro que desea restaurar los conteos?"
                            }

                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="secondary" onClick={this.props.handleClose}>
                        Cancelar
                    </Button>
                    <Button variant="contained" color="primary" onClick={this.restaurarConteo} disabled={this.state.motivo === ""}>
                        Restaurar
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default DialogRestaurarConteoEliminado